var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gateway-block"},[_c('div',{staticClass:"category-title"},[_c('h1',{staticClass:"h1-like"},[_vm._v(_vm._s(_vm.$t("gateways.title")))]),_c('gateway-add',{ref:"gatewayModal"})],1),_c('gatewayPlate')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }